import { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import TeamContent from './TeamContent';
import FALLBACK from './teamDefaults.json';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// "Our Team" — the company story, roles/hierarchy and the people behind the platform. Content is
// website-owner configurable (GET /api/team-profiles/platform, edited from any vertical's
// AdminDashboard > Team page tab). Falls back to teamDefaults.json when the API is unavailable,
// same pattern as BusinessesModal.
export default function TeamModal({ show, onHide }) {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!show || loaded) return;
    let cancelled = false;
    axios.get(`${API_BASE_URL}/api/team-profiles/platform`)
      .then((res) => {
        if (cancelled) return;
        setData(res.data?.data && (res.data.data.members?.length || res.data.data.story?.length)
          ? res.data.data : FALLBACK);
        setLoaded(true);
      })
      .catch(() => { if (!cancelled) { setData(FALLBACK); setLoaded(true); } });
    return () => { cancelled = true; };
  }, [show, loaded]);

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable centered>
      <Modal.Header closeButton>
        <Modal.Title>Our Team</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!data ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" role="status" /></div>
        ) : (
          <TeamContent data={data} apiBase={API_BASE_URL} />
        )}
      </Modal.Body>
    </Modal>
  );
}
